import React, { Fragment, useEffect } from 'react'
import BubbleLoader from './BubbleLoader'
import './styles/modal.scss'

const Modal = (props) => {
    const {
        children,
        cssClass,
        size,
        style,
        show,
        onClose,
        overflowAuto,
        loading,
        id,
        nestedModal,
        containsScroll,
    } = props

    useEffect(() => {
        if (show) {
            // hide page scroll & only show modal scroll
            document.body.style.overflow = overflowAuto ? 'auto' : 'hidden'
        }
        return () => {
            // keep `show` in conditional because on window resize other (closed) modals might trigger this
            if (!nestedModal && show) document.body.style.overflow = 'auto'
        }
    }, [show])

    if (!show) return null

    let modalBgClass = 'modalBackground'
    modalBgClass += overflowAuto ? ' bg-light' : ' bg-dark'
    modalBgClass += containsScroll ? ' containsScroll' : ''

    let modalContainerClass = cssClass ?? ''
    modalContainerClass += containsScroll ? ' containsScroll' : ''
    modalContainerClass += size ? ` ${size}` : ''

    return (
        <Fragment>
            <div
                id={id}
                className={modalBgClass}
            >
                <div className={`uc-modal ${modalContainerClass}`} style={style}>
                    <div className="modal-wrapper">
                        {loading ? <BubbleLoader /> : children}
                        <button type="button" onClick={onClose} className="closeButton">
                            <i className="fa-regular fa-xmark" />
                        </button>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Modal
